// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  // baseURL: 'http://localhost:4200',
  // URL_API : 'https://pruebas2.egm-robotics.com',

  // baseURL vacío => las navegaciones (login, ventana1, postulaciones, etc.)
  // usan rutas relativas y se mantienen en el mismo dominio (localhost en dev)
  baseURL: '',
  URL_API : 'https://www.practicasejemplaresecuador.com',
};
